var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Checkout = YouLi.Trip.Checkout ? YouLi.Trip.Checkout : {};

(function (YouLi) {
    (function (Trip) {
        (function (Checkout) {

            let prevState = {
                isPackageCategory: false
            }

            var GetGangSetupContext = function (tripType) {
                var normalisedTripType = (tripType || "main").toString().toLowerCase();

                switch (normalisedTripType) {
                    case "pre":
                        return { parentSelector: "#PreTourGangSetup", fieldPrefix: "PreTour", tripType: "pre" };
                    case "post":
                        return { parentSelector: "#PostTourGangSetup", fieldPrefix: "PostTour", tripType: "post" };
                    case "main":
                    default:
                        return { parentSelector: "#MainTourGangSetup", fieldPrefix: "MainTour", tripType: "main" };
                }
            }

            // Gang Management Event Handlers
            let gangSetupCurrentGangIndex = -1;

            YouLi.Trip.Checkout.PaymentGateway = {
                Stripe: 0,
                Square: 1,
                CyberSource: 2,
                AuthorizeNet: 3
            };
            YouLi.Trip.Checkout.ConnectedPaymentGateway = YouLi.Trip.Checkout.PaymentGateway.Stripe;
            YouLi.Trip.Checkout.StripeHandler = undefined;
            YouLi.Trip.Checkout.AuthorizeNetClientKey = "";
            YouLi.Trip.Checkout.AuthorizeNetAPIKey = "";
            YouLi.Trip.Checkout.Name = "";
            YouLi.Trip.Checkout.Description = "";
            YouLi.Trip.Checkout.ThirdPartyCardSurchargePercent = 0;
            YouLi.Trip.Checkout.RefundProtectPercent = 0;
            YouLi.Trip.Checkout.AllowRefundablePayments = false;
            YouLi.Trip.Checkout.CurrencyHasDecimals = true;

            YouLi.Trip.Checkout.RefundProtectTotalCostEstimate = 0;
            YouLi.Trip.Checkout.RefundProtectOptedOutConfirmed = false;
            YouLi.Trip.Checkout.PrepayTotal = 0;
            YouLi.Trip.Checkout.CouponCodeAmountApplied = 0;
            YouLi.Trip.Checkout.InviteeReferenceCode = "";

            YouLi.Trip.Checkout.SquareApplicationId = '';
            YouLi.Trip.Checkout.SquareLocationId = '';
            YouLi.Trip.Checkout.SquarePaymentForm = null;

            YouLi.Trip.Checkout.PayNowButtonText = "Pay Now";
            YouLi.Trip.Checkout.NotifyPlannerButtonText = "Notify Planner";

            YouLi.Trip.Checkout.SelectedInstallmentId = "";
            YouLi.Trip.Checkout.InstallmentIdBalance = undefined;
            YouLi.Trip.Checkout.InstallmentIdOther = undefined;

            YouLi.Trip.Checkout.EmailDomainValidationWhitelist = [];
            YouLi.Trip.Checkout.EmailDomainValidationErrorText = "";

            YouLi.Trip.Checkout.BookingAddOnOptions = [];
            YouLi.Trip.Checkout.ApplySurchargeToAllMethods = false;

            YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode = function () {
                if ($('input[type=radio][name="CurrentInvitee.GangInvoiceAndViewMode"]').length > 0) {
                    return $('input[type=radio][name="CurrentInvitee.GangInvoiceAndViewMode"]:checked').val();
                }
                else {
                    return $('input[name="CurrentInvitee.GangInvoiceAndViewMode"]').val();
                }
            }

            YouLi.Trip.Checkout.GetRefundProtectSelection = function () {
                if ($('input[type=radio][name="CurrentInvitee.RefundProtectSelection"]').length > 0) {
                    return $('input[type=radio][name="CurrentInvitee.RefundProtectSelection"]:checked').val();
                }
                else {
                    return $('input[name="CurrentInvitee.RefundProtectSelection"]').val();
                }
            }

            YouLi.Trip.Checkout.InitialiseResponseChecks = function () {

                $(".content-checkout-itinerary-addons .multistate-check-schedule-item-response").multiStateCheck({
                    states: ["unchecked", "checked"],
                    onAfterChangeState: function (e) {
                        const targetElement = e.target;

                        const $current = $(e.target);
                        const itemId = $current.data("id");
                        const $allCheckboxes = $(`.content-checkout-itinerary-addons .multistate-check-schedule-item-response[data-id="${itemId}"]`);
                        const $first = $allCheckboxes.first();
                        let responseValue = "";
                        const isRespondingForGang = $(targetElement).data("is-responding-for-gang");

                        if ($(targetElement).attr("data-state") == "checked")
                            responseValue = "yes";
                        else
                            responseValue = "no";

                        if (!$current.is($first)
                            && $current.attr("data-state") === "checked"
                            && $first.attr("data-state") !== "checked"
                            && $first.data("is-responding-for-gang")) {
                            $current.attr("data-state", "unchecked");
                            return;
                        }

                        YouLi.Common.UI.ShowLoading();

                        if (isRespondingForGang) {
                            $(`.multistate-check-schedule-item-response[data-id="${itemId}"]`).attr('data-state', $(targetElement).attr("data-state"));
                        }

                        YouLi.Trip.Checkout.DoItemResponse(itemId, responseValue, targetElement, function () {

                            // toggle where the cost for addon is shown (depending on whether they are going or not)
                            const targetElementItineraryItemContainer = $(targetElement).closest(".addon-item-container");
                            $(targetElementItineraryItemContainer).find(".cost-label").toggleClass("hidden", responseValue == "yes")
                            $(targetElementItineraryItemContainer).find(".cost-line-item-amount").toggleClass("hidden", responseValue != "yes")

                            YouLi.Common.UI.HideLoading();
                        });
                    }
                })
            };

            YouLi.Trip.Checkout.DoItemResponse = function (itemId, responseValue, element, callback) {

                let targetElement = element;

                let data = {
                    Preview: $("#PreviewMode").val(),
                    IsReservation: $("#IsReservation").val(),
                    ScheduleItemId: itemId,
                    InviteeId: $(element).data("invitee-id"),
                    ResponseValue: responseValue,
                    SelectedTripPackageId: $("#SelectedPackageId").val(),
                    SelectedBookingAddOnOptionId: $("input[type=radio][name=BookingAddOnOption]:checked").val(),
                    inviteesWithAddOnResponses: GetInviteeDetailsData(),
                    gangs: GetGangsDetailsData($("#MainTourGangSetup")),
                    preTripGangs: GetGangsDetailsData($("#PreTourGangSetup")),
                    postTripGangs: GetGangsDetailsData($("#PostTourGangSetup")),
                    numberInviteesInCheckout: $("#NumberInviteesInCheckout").val(),
                };

                data.gangInvoiceAndViewMode = YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode();

                YouLi.Common.Post({
                    url: '/trip/checkoutinviteeschedulerespond',
                    params: data,
                    suppressLoading: true,
                    errorCallback: function () {
                        YouLi.Common.UI.HideLoading();
                        YouLi.Common.UI.ShowStandardDialog("An error occurred.");

                        $(targetElement).data("multiStateCheck").revert();
                    }
                }).then(function (response) {

                    if (response.url) {
                        YouLi.Common.UI.HideLoading();
                        window.location.href = response.url;
                    }
                    else if (response.success === false) {
                        YouLi.Common.UI.HideLoading();
                        YouLi.Common.UI.ShowStandardDialog("An error occurred.");

                        $(targetElement).data("multiStateCheck").revert();
                    }
                    else {

                        var initialSelectedInvoiceAndViewMode = $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode']:checked").val();
                        var initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]:checked").val();
                        var initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();

                        if (response.isFreePackage) {
                            $(".page-fold-right").addClass("free-package-view");
                        } else {
                            $(".page-fold-right").removeClass("free-package-view");
                        }

                        $(".content-trip-checkout-paymentdetails-costs").html(response.paymentDetailsHtml);

                        YouLi.Trip.Checkout.InitialiseResponseChecks();
                        YouLi.Common.UI.Init();

                        initialiseValidator();

                        if (!initialSelectedPaymentMethod)
                            initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]").first().val();
                        if (!initialSelectedPaymentOption)
                            initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]").first().val();

                        $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode'][value=" + initialSelectedInvoiceAndViewMode + "]").attr("checked", true);
                        $("input[type=radio][name=PaymentMethod][value=" + initialSelectedPaymentMethod + "]").attr("checked", true);
                        $("input[type=radio][name=PaymentOption][value=" + initialSelectedPaymentOption + "]").attr("checked", true);
                        InitialisePaymentDetails();

                        if (callback) {
                            callback();
                        }
                    }
                });


            };

            YouLi.Trip.Checkout.UpdateInviteesAndPrice = function (preserveNumberInviteesInCheckout = false, gangOptions) {

                const defaultPromise = new Promise((resolve, reject) => {
                    resolve('Success!');
                });

                let data = {
                    packageId: $("#SelectedPackageId").val(),
                    bookingAddOnOptionId: $("input[type=radio][name=BookingAddOnOption]:checked").val(),
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    preview: $("#PreviewMode").val(),
                    inviteesWithAddOnResponses: GetInviteeDetailsData(),
                    isReservation: $("#IsReservation").val(),
                }

                // Add gangs data if gang management is enabled
                var mainTourGangsData = GetGangsDetailsData($("#MainTourGangSetup"));
                if (mainTourGangsData.length > 0 || gangOptions) {
                    data.gangs = mainTourGangsData;
                }

                var preTourGangsData = GetGangsDetailsData($("#PreTourGangSetup"));
                if (preTourGangsData.length > 0 || gangOptions) {
                    data.preTripGangs = preTourGangsData;
                }

                var postTourGangsData = GetGangsDetailsData($("#PostTourGangSetup"));
                if (postTourGangsData.length > 0 || gangOptions) {
                    data.postTripGangs = postTourGangsData;
                }

                if (gangOptions) {
                    data.addGang = (gangOptions && gangOptions.addGang) || false;
                    data.removeGangIndex = (gangOptions && gangOptions.removeGangIndex !== undefined) ? gangOptions.removeGangIndex : -1;
                    data.gangChangeTrip = gangOptions.affectedTrip
                }

                data.gangInvoiceAndViewMode = YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode();

                if (preserveNumberInviteesInCheckout) {
                    data.numberInviteesInCheckout = $("#NumberInviteesInCheckout").val();
                }

                return YouLi.Common.Post({
                    url: '/trip/UpdateCheckoutInviteesAndPrice/',
                    params: data,
                }).then(function (response) {
                    if (response.url) {
                        window.location.href = response.url;
                    }
                    else if (response.success === false) {
                        YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                    }
                    else {

                            //google analytics
                            PushRemoveCartGAData();
                            $("#GoogleAnalyticsData").html(response.googleAnalyticsHtml);
                            PushAddCartGAData();

                            var initialSelectedInvoiceAndViewMode = $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode']:checked").val();
                            var initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]:checked").val();
                            var initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();

                            if (response.isFreePackage) {
                                $(".page-fold-right").addClass("free-package-view");
                            } else {
                                $(".page-fold-right").removeClass("free-package-view");
                            }

                            $(".content-trip-checkout-paymentdetails-costs").html(response.paymentDetailsHtml);

                            $(".package-card").html(response.packageCardHtml);
                            $(".invitees-setup").html(response.inviteesSetupHtml);

                            // Only show the button to view the invoice button if the invoice is actually showing now
                            $("#ViewInvoiceButton").toggle($(".pay-now-button").length > 0); 

                            // Update gangs section if HTML is provided
                            if (response.mainTourGangSetupHtml && $("#MainTourGangSetup").length > 0) {
                                $("#MainTourGangSetup .gangs-setup-container").html(response.mainTourGangSetupHtml);
                            }

                            if (response.preTourGangSetupHtml && $("#PreTourGangSetup").length > 0) {
                                $("#PreTourGangSetup").html(response.preTourGangSetupHtml);
                            }

                            if (response.postTourGangSetupHtml && $("#PostTourGangSetup").length > 0) {
                                $("#PostTourGangSetup").html(response.postTourGangSetupHtml);
                            }

                            $(".page-fold-right").toggleClass("sold-out-view", !response.packageIsAvailable);
                            $(".page-fold-right").toggleClass("trip-full-view", response.isFull);
                            $(".page-fold-right").toggleClass("trip-full-view", response.wouldOverbook);

                            if (response.packageIsAvailable) {

                                YouLi.Trip.Checkout.InitialiseResponseChecks();

                                initialiseValidator();

                                // initially select the first payment option and payment method
                                if (!initialSelectedPaymentMethod)
                                    initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]").first().val();
                                if (!initialSelectedPaymentOption)
                                    initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]").first().val();

                                $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode'][value=" + initialSelectedInvoiceAndViewMode + "]").attr("checked", true);
                                $("input[type=radio][name=PaymentMethod][value=" + initialSelectedPaymentMethod + "]").attr("checked", true);
                                $("input[type=radio][name=PaymentOption][value=" + initialSelectedPaymentOption + "]").attr("checked", true);
                                InitialisePaymentDetails();
                            }

                            ClearArrivalDepartureDateEvents();  // clear event handlers for dates which will be re-initialised

                            YouLi.Common.UI.Init();

                            SetupArrivalDepartureDateEvents();

                            InitialiseGangEmailEvent();

                            // Re-Initialise gang event handlers if gangs section exists
                            if ($(".gangs-setup").length > 0) {
                                InitialiseGangEventHandlers();
                            }

                            $('.gang-email').trigger('blur');

                            const currentState = $('.gang-member').find('#GangInvitees_0__InviteeCategory').is(':hidden');

                            if (prevState.isPackageCategory) {
                                if (currentState !== prevState.isPackageCategory) {
                                    $('.gang-member').each((index, element) => {
                                        $(element).find(`#GangInvitees_${index}__InviteeCategory`).val(null);
                                    });
                                }
                            }

                            prevState.isPackageCategory = currentState;

                            YouLi.Trip.SurchargeCapping.Init();
                        }

                });

                return defaultPromise;
            }

            /* Returns a promise */
            YouLi.Trip.Checkout.ProcessGenericCreditCardPayment = function (nonce, paymentMethod) {

                if (nonce) {
                    var $form = $('#PaymentChargeForm');

                    $("#chargeNonce").remove();
                    $form.append($('<input type="hidden" id="chargeNonce" name="chargeNonce">').val(nonce));
                }

                return processCheckout(paymentMethod);
            };

            YouLi.Trip.Checkout.ProcessPaymentWithSavedPaymentMethod = function (isThirdPartyCard) {

                let newPaymentId, couponPaymentId;
                var redirectURL = window.location.href;

                if (YouLi.Trip.Checkout.ConnectedPaymentGateway !== YouLi.Common.PaymentGateway.Stripe) {
                    return Promise.resolve();
                }

                var gaData = YouLi.Common.GetGAData("begin_checkout");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(gaData);

                const savedPaymentMethodId = isThirdPartyCard ? $("#ThirdPartyCardPaymentMethodId").val() : $("#SavedPaymentMethodId").val();

                return YouLi.CreditCardPaymentForm.StripePay.InitialiseStripe()
                    .then(() => YouLi.Trip.Checkout.ProcessGenericCreditCardPayment(undefined, "stripe"))
                    .then((data) => {

                        newPaymentId = data.newPaymentId;
                        couponPaymentId = data.couponPaymentId;

                        if (data.redirectURL) {
                            redirectURL = data.redirectURL;
                        }

                        if (!newPaymentId) {
                            var userMessage = "An error occurred with the payment charge - invalid payment Id";
                            var debugMessage = "Credit Card failure: passed a " + (newPaymentId == null ? "null" : "empty string") + " for paymentId on trip "
                                + $("#TripId").val() + " for invitee " + $("#InviteeId").val() + " is failing. Domain: " + window.location.host;
                            var subject = "Exception occurring - internalPaymentId is being set to an invalid value in Stripe Payment Intent";

                            YouLi.Common.OpenSupportTicket(userMessage, debugMessage, subject);

                            throw new Error(userMessage);
                        }

                        return YouLi.Trip.Checkout.ChargeStripeSavedPaymentMethod(newPaymentId, redirectURL, isThirdPartyCard, savedPaymentMethodId);
                    })
                    .then((data) => {
                        if (data.redirectURL) {
                            redirectURL = data.redirectURL;
                        }

                        if (window.location.href == redirectURL)
                            window.location.reload();
                        else
                            window.location.href = redirectURL;
                    })
                    .catch((errorObject) => {
                        console.error('Error:', errorObject.message);

                        var paymentsToDelete = [];
                        if (newPaymentId)
                            paymentsToDelete.push(newPaymentId);
                        if (couponPaymentId)
                            paymentsToDelete.push(couponPaymentId);

                        YouLi.Trip.Checkout.CancelCheckout(paymentsToDelete);

                        YouLi.Common.UI.HideInputLoading($(".pay-now-button"));

                        if (!errorObject.errorHandled) {
                            YouLi.Trip.Checkout.ShowErrorOnPage(errorObject.message, moment());
                        }
                    });
            }

            YouLi.Trip.Checkout.ShowErrorOnPage = function (errorMessage, errorDate /* a Moment date */) {
                $(".checkout-payment-error").removeClass("hidden");

                if (errorDate)
                    $("#PaymentErrorDate").text(errorDate.format("D MMM YYYY") + " @ " + errorDate.format("h:mma"));

                $("#PaymentErrorMessage").text(errorMessage);

                if ($('#GenericPaymentFormDialog'))
                    $('#GenericPaymentFormDialog').modal('hide');
            };

            var GetInviteeDetailsData = function () {
                var inviteeDetails = [];
                $(".gang-member").each((index, element) => {

                    const inviteeId = $(element).find(`#GangInvitees_${index}__Id`).val();
                    inviteeDetails[index] = {
                        "id": inviteeId,
                        "firstname": $(element).find(`#GangInvitees_${index}__FirstName`).val(),
                        "lastname": $(element).find(`#GangInvitees_${index}__LastName`).val(),
                        "email": $(element).find(`#GangInvitees_${index}__Email`).val(),
                        "phonenumber": $(element).find(`#GangInvitees_${index}__PhoneNumber`).val(),
                        "referencecode": $(element).find(`#GangInvitees_${index}__ReferenceCode`).val(),
                        "arrivaldate": $("#CurrentInvitee_GangInvitees_0__ArrivalDate").val(),   // nb: always using the first gang member's date
                        "departuredate": $("#CurrentInvitee_GangInvitees_0__DepartureDate").val(),   // nb: always using the first gang member's date
                        "optedinaddonids": $(`.multistate-check-schedule-item-response[data-invitee-id=${inviteeId}][data-state=checked]`).map(function () {
                            return $(this).data('id');
                        }).get(),
                        "inviteecategory": $(element).find(`#GangInvitees_${index}__InviteeCategory`).val()
                    }

                    // create an array of profile field data
                    inviteeDetails[index].ProfileFormTaskResponseFields = [];

                    $(element).find(".profile-field").each((fieldIndex, fieldElement) => {
                        const fieldType = $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__FieldType`).val();
                        const responseValue = fieldType === 'yesno'
                            ? $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__ResponseValue:checked`).val()
                            : $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__ResponseValue`).val();

                        inviteeDetails[index].ProfileFormTaskResponseFields[fieldIndex] = {
                            IsSystemField: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__IsSystemField`).val(),
                            IsPrimarySystemField: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__IsPrimarySystemField`).val(),
                            APIFieldName: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__APIFieldName`).val(),
                            FieldType: fieldType,
                            TaskItemFormBuilderFieldId: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__TaskItemFormBuilderFieldId`).val(),
                            IsRequired: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__IsRequired`).val(),
                            Label: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__Label`).val(),
                            ResponseValue: responseValue,
                            CustomOptionMultipleAnswers: $(fieldElement).find(`input[name="GangInvitees[${index}].ProfileFormTaskResponseFields[${fieldIndex}].CustomOptionMultipleAnswers"]:checked`)
                                .map(function () {
                                    return $(this).val();
                                }).toArray(),
                            FlightField: fieldType === 'flightarrival' || fieldType === 'flightdeparture'
                                ? {
                                    FlightDate: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__FlightField_FlightDate`).val(),
                                    FlightAirlineCode: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__FlightField_FlightAirlineCode`).val(),
                                    FlightNumber: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__FlightField_FlightNumber`).val(),
                                    FlightChecked: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__FlightField_FlightChecked`).val(),
                                    CheckedFlightResultJson: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__FlightField_CheckedFlightResultJson`).val()
                                }
                                : null
                        }
                    });

                    inviteeDetails[index].ProfileFormTaskResponseFields = inviteeDetails[index].ProfileFormTaskResponseFields.filter(function (field) {
                        return field.IsPrimarySystemField.toLowerCase() === "false";
                    });
                });

                return inviteeDetails;
            };

            var GetGangsDetailsData = function (parentElement) {
                var gangsData = [];

                var $parent = parentElement ? $(parentElement) : $();
                if ($parent.length === 0) {
                    return gangsData;
                }

                // Only collect gang data if the gangs section exists
                if ($parent.find(".gang-item").length === 0) {
                    return gangsData;
                }

                var fieldPrefix = "MainTour";
                var parentId = $parent.attr("id");
                if (parentId === "PreTourGangSetup") {
                    fieldPrefix = "PreTour";
                }
                else if (parentId === "PostTourGangSetup") {
                    fieldPrefix = "PostTour";
                }

                $parent.find(".gang-item").each(function (index) {
                    var $gang = $(this);
                    var assignedInviteeIds = [];

                    // Collect assigned invitee IDs
                    $gang.find(`input[name^="${fieldPrefix}Gangs[${index}].AssignedInviteeIds"]`).each(function () {
                        var inviteeId = $(this).val();
                        if (inviteeId) {
                            assignedInviteeIds.push(inviteeId);
                        }
                    });

                    gangsData.push({
                        id: $gang.find(`input[name="${fieldPrefix}Gangs[${index}].Id"]`).val(),
                        packageId: $gang.find(`select[name="${fieldPrefix}Gangs[${index}].PackageId"]`).val(),
                        assignedInviteeIds: assignedInviteeIds,
                        reservationNumber: $("#ChargeReservationNumber").val(),
                    });
                });

                return gangsData;
            };


            YouLi.Trip.Checkout.CancelCheckout = function (paymentIdsToDelete) {

                if (!paymentIdsToDelete || paymentIdsToDelete.length == 0)
                    return Promise.resolve();

                // For checkout, we are going to delete the entire invitee, so just pass the first payment Id

                return YouLi.Common.Get({
                    url: '/trip/cancelinprogresscheckout',
                    params: {
                        tripId: $("#TripId").val(),
                        paymentId: paymentIdsToDelete[0]
                    },
                    suppressLoading: true
                });
            };

            var ChangePaymentOption = function (selectedOption, refreshInstallmentsTable = false) {

                $(".installments-details").addClass("hidden");

                if (selectedOption == "installment") {
                    $(".installments-details").removeClass("hidden");
                }

                // If credit card payemnt form is loaded (it won't be initially for $0 packages)
                if (YouLi.CreditCardPaymentForm) {
                    YouLi.CreditCardPaymentForm.UpdateAutoPayVisibility(selectedOption != "balance");
                }

                // Reset the selected installment value
                if (selectedOption == "installment")
                    YouLi.Trip.Checkout.SelectedInstallmentId = YouLi.Trip.Checkout.InstallmentIdOther;
                else
                    YouLi.Trip.Checkout.SelectedInstallmentId = YouLi.Trip.Checkout.InstallmentIdBalance;

                if (YouLi.Trip.Checkout.SelectedInstallmentId != null) {
                    TogglePaymentButtonVisiblity();

                    // now update the actual payment amount
                    GetSelectedPaymentOptionAmount(refreshInstallmentsTable);
                }
            }

            var ChangeMethodOrOptions = function (selectedMethod) {

                var selectedPaymentMethodElement = $('input[type=radio][name=PaymentMethod]:checked');

                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();

                // hide all and then show whichever is needed
                $(".cost-line-item-credit-card-surcharge, .cost-line-item-surcharge").addClass("hidden");
                $(".payment-surcharge-val").addClass("hidden");
                $(".cost-line-item-refund-protect").addClass("hidden");
                $(".refund-protect-val").addClass("hidden");
                $("#RefundProtectSelection").addClass("hidden");
                $(".payment-method-details").addClass("hidden");

                $("#ThirdPartyCardDetails").addClass("hidden");
                $("#CustomLinkDetails").addClass("hidden");
                $("#PhoneDetails").addClass("hidden");
                $("#BankTransferDetails").addClass("hidden");

                //// standard labels
                let isPackageSoldout = $(".pay-now-button-label").data('sold-out');
                if (isPackageSoldout) {
                    $(".pay-now-button-label").text("Sold Out");
                } else {
                    $(".pay-now-button-label").text(YouLi.Trip.Checkout.PayNowButtonText);
                }

                switch (selectedMethod) {
                    case "savedpaymentmethod":
                        //$("#PayPaymentGateway").removeClass("hidden");

                        if (selectedPaymentOption) {
                            if (YouLi.PaymentChargeForm.Default.SurchargePercent > 0 && YouLi.PaymentChargeForm.Ach.HasSurcharge === false) {
                                $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".payment-surcharge-val").removeClass("hidden");
                            }
                        }
                        break;
                    case "thirdpartycard":
                        if (selectedPaymentOption) {
                            if (YouLi.Trip.Checkout.ThirdPartyCardSurchargePercent > 0) {
                                $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".payment-surcharge-val").removeClass("hidden");
                            }
                        }
                        $("#ThirdPartyCardDetails").removeClass("hidden");
                        break;
                    case "paymentgateway":
                        $("#PayPaymentGateway").removeClass("hidden");

                        if (selectedPaymentOption) {
                            if (YouLi.PaymentChargeForm.Default.SurchargePercent > 0 && YouLi.PaymentChargeForm.Ach.HasSurcharge === false) {
                                $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".payment-surcharge-val").removeClass("hidden");
                            }
                        }
                        break;
                    case "banktransfer":
                        $("#PayBankTransfer").removeClass("hidden");
                        $("#BankTransferDetails").removeClass("hidden");
                        // override some labels
                        if (isPackageSoldout) {
                            $(".pay-now-button-label").text("Sold Out");
                        } else {
                            $(".pay-now-button-label").text(YouLi.Trip.Checkout.NotifyPlannerButtonText);
                        }
                        break;
                    case "paypallink":
                        $("#PayPayPalLink").removeClass("hidden");
                        break;
                    case "phone":
                        $("#PayPhone").removeClass("hidden");
                        $("#PhoneDetails").removeClass("hidden");
                        if (isPackageSoldout) {
                            $(".pay-now-button-label").text('Sold Out');
                        } else {
                            var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
                            $(".pay-now-button-label").text(isMobile ? YouLi.Trip.Checkout.PayNowButtonText : YouLi.Trip.Checkout.NotifyPlannerButtonText);
                        }

                        break;
                    case "customlink":
                        $("#CustomLinkDetails").removeClass("hidden");
                        break;
                }

                ToggleRefundProtectVisiblity();

                TogglePaymentButtonVisiblity();

                // update the charge details if they have selected a method - we have to redo this here because of method-based surcharges
                if (selectedMethod)
                    UpdateChargeDetails(undefined);
            };

            var ToggleRefundProtectVisiblity = function () {
                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                if (selectedPaymentMethod) {
                    if (selectedPaymentOption) {
                        $(".cost-line-item-refund-protect").removeClass("hidden");
                        $(".refund-protect-val").removeClass("hidden");
                    }

                    if (YouLi.Trip.Checkout.RefundProtectPercent > 0) {
                        $("#RefundProtectSelection").removeClass("hidden");
                    }
                }

            }

            var TogglePaymentButtonVisiblity = function () {
                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                $(".payment-button").toggleClass("hidden", !(selectedPaymentMethod && selectedPaymentOption)); // only show if a method AND the payment option have both been selected
            }

            var UpdateChargeLabelFromPrimaryInvitee = function () {

                let label = $("input[Name=ChargeLabel]").val();

                label = label.replace("[NAME]", `${$("#GangInvitees_0__FirstName").val()} ${$("#GangInvitees_0__LastName").val()}`);

                $("input[Name=ChargeLabel]").val(label);
            }

            var UpdateBillToEmailFromPrimaryInvitee = function () {

                let billToEmail = $("input[Name=billtoemail]");

                if (billToEmail.length > 0) {
                    billToEmail.val($("#GangInvitees_0__Email").val());
                    billToEmail.prop("readOnly", billToEmail.val().length > 0)
                }
            }

            var UpdateTotalAmountDue = function () {
                $("input[Name=ChargeAmount]").val(YouLi.PaymentChargeForm.GetChargeAmount());
            }

            var GetSelectedBookingAddOnOption = function () {
                let selectedBookingAddOnOptionId = $('input[type=radio][name=BookingAddOnOption]:checked').val();

                if (YouLi.Trip.Checkout.BookingAddOnOptions.length == 0)
                    return undefined;

                return YouLi.Trip.Checkout.BookingAddOnOptions.find((item) => {
                    return item.Id == selectedBookingAddOnOptionId;
                });
            };

            var GetBookingAddOnOptionTotalPriceDue = function () {
                let result = 0;

                if (YouLi.Trip.Checkout.BookingAddOnOptions.length > 0 && $('input[type=radio][name=BookingAddOnOption]').length > 0) {
                    const selectedBookingAddOnOption = GetSelectedBookingAddOnOption();

                    const numTravellersMultiplier = $("#SelectedTripPackageNumTravellers").val() > 1 ? $("#SelectedTripPackageNumTravellers").val() : 1;

                    const numberInviteesInCheckout = $("#NumberInviteesInCheckout").length > 0 ? $("#NumberInviteesInCheckout").val() : 1;

                    if (YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode() == "paytogether")
                        result = selectedBookingAddOnOption.PricePerPerson * numberInviteesInCheckout * numTravellersMultiplier;
                    else
                        result = selectedBookingAddOnOption.PricePerPerson * numTravellersMultiplier;
                }

                return result;
            };

            var GetBookingAddOnOptionTotalPriceForGang = function () {
                let result = 0;

                if (YouLi.Trip.Checkout.BookingAddOnOptions.length > 0 && $('input[type=radio][name=BookingAddOnOption]').length > 0) {
                    const selectedBookingAddOnOption = GetSelectedBookingAddOnOption();

                    const numTravellersMultiplier = $("#SelectedTripPackageNumTravellers").val() > 1 ? $("#SelectedTripPackageNumTravellers").val() : 1;

                    const numberInviteesInCheckout = $("#NumberInviteesInCheckout").length > 0 ? $("#NumberInviteesInCheckout").val() : 1;

                    result = selectedBookingAddOnOption.PricePerPerson * numberInviteesInCheckout * numTravellersMultiplier;
                }

                return result;
            };

            var UpdateChargeDetails = function (label) {

                /// Add surcharge and any other charges to the amount before setting
                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                let selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                YouLi.PaymentChargeForm.BookingAddOnAmountDue = GetBookingAddOnOptionTotalPriceDue();

                if (YouLi.Trip.Checkout.BookingAddOnOptions.length > 0 && $('input[type=radio][name=BookingAddOnOption]').length > 0) {
                    const selectedBookingAddOnOption = GetSelectedBookingAddOnOption();

                    $("#TripBookingAddonOptionConsentText").html(selectedBookingAddOnOption.ConsentPrompt);
                }

                let surchargeAmount = 0;
                let totalAmountDue = 0;

                if (selectedPaymentMethod === "thirdpartycard") {
                    surchargeAmount = parseFloat(((YouLi.PaymentChargeForm.AmountDue + YouLi.PaymentChargeForm.BookingAddOnAmountDue) * YouLi.Trip.Checkout.ThirdPartyCardSurchargePercent / 100).toFixed(2));
                    $(".payment-surcharge-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);
                    $(".cost-line-item-surcharge-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);

                    if (selectedPaymentOption
                        && YouLi.Trip.Checkout.ThirdPartyCardSurchargePercent > 0) {
                        $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                        $(".cost-line-item-surcharge-val").removeClass("hidden");
                    }
                }
                else if (selectedPaymentMethod === "paymentgateway") {
                    surchargeAmount = parseFloat(YouLi.PaymentChargeForm.GetSurchargeAmount(null).toFixed(2));
                    $(".payment-surcharge-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);
                    $(".cost-line-item-surcharge-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);

                    if (selectedPaymentOption
                        && YouLi.PaymentChargeForm.Default.SurchargePercent > 0
                        && YouLi.PaymentChargeForm.Ach.HasSurcharge === false) {
                        $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                        $(".cost-line-item-surcharge-val").removeClass("hidden");
                    }
                }
                else if (YouLi.Trip.Checkout.ApplySurchargeToAllMethods) {
                    // this is for payments like bank transfer, phone, custom link, etc. where the planner has set a surcharge to apply to all methods
                    surchargeAmount = parseFloat(YouLi.PaymentChargeForm.GetSurchargeAmount(null).toFixed(2));
                    $(".payment-surcharge-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);
                    $(".cost-line-item-surcharge-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);
                    if (selectedPaymentOption && YouLi.PaymentChargeForm.Default.SurchargePercent > 0) {
                        $(".cost-line-item-surcharge").removeClass("hidden");
                        $(".cost-line-item-surcharge-val").removeClass("hidden");
                    }
                }

                totalAmountDue = YouLi.PaymentChargeForm.AmountDue + YouLi.PaymentChargeForm.BookingAddOnAmountDue + surchargeAmount;

                var tripTotal = YouLi.Trip.Checkout.PrepayTotal - YouLi.Trip.Checkout.CouponCodeAmountApplied;

                // add Refund Protect (if applicable and selected)
                $(".cost-line-item-refund-protect").addClass("hidden");
                $(".refund-protect-val").addClass("hidden");
                let refundProtectAmount = 0;
                let refundPercentage = 0;
                if (YouLi.Trip.Checkout.RefundProtectPercent > 0
                    && selectedPaymentOption
                    && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val() != undefined
                    && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val().toLowerCase() == "optedin"
                ) {

                    refundProtectAmount = parseFloat((totalAmountDue * YouLi.Trip.Checkout.RefundProtectPercent / 100).toFixed(2));
                    refundPercentage = YouLi.Trip.Checkout.RefundProtectPercent;
                    $(".refund-protect-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(refundProtectAmount)}`);

                    $(".cost-line-item-refund-protect").removeClass("hidden");
                    $(".refund-protect-val").removeClass("hidden");

                    if (!YouLi.Trip.Checkout.AllowRefundablePayments)
                        tripTotal += YouLi.Trip.Checkout.RefundProtectTotalCostEstimate;
                }
                else {
                    $(".cost-line-item-refund-protect").addClass("hidden");
                    $(".refund-protect-val").addClass("hidden");
                }

                // Update booking add-on if in use
                if ($(".cost-line-item-amount-booking-add-on-total").length > 0) {

                    $(".booking-add-on-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.BookingAddOnAmountDue)}`);

                    const bookingAddOnOptionTotalPriceForGang = GetBookingAddOnOptionTotalPriceForGang();
                    $(".cost-line-item-amount-booking-add-on-total").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(bookingAddOnOptionTotalPriceForGang)}`);
                }

                // update the trip total to include any extras (e.g. RP and booking add-on)
                $(".cost-line-item-amount-total").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(tripTotal)}`);

                $(".cost-line-item-installment-total").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.AmountDue));

                $(".cost-line-item-amount-due").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.AmountDue));

                YouLi.PaymentChargeForm.UpdatePaymentInfo({
                    surchargeAmount: surchargeAmount,
                    refundProtectAmount: refundProtectAmount,
                    refundProtectPercent: refundPercentage
                });

                if (selectedPaymentMethod === "creditcard" && YouLi.PaymentChargeForm.Ach.HasSurcharge === true) {
                    $(".cost-line-item-amount-payment-total").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmountNoSurcharge()));
                    $('#GenericPaymentFormDialog')
                        .find('.cost-line-item-amount-payment-total')
                        .html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));
                } else {
                    $(".cost-line-item-amount-payment-total").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));
                }

                $("input[Name=RefundProtectAmount]").val(refundProtectAmount);
                UpdateTotalAmountDue();
                $("input[Name=SurchargeAmount]").val(surchargeAmount);

                if (label) {
                    $("input[Name=ChargeLabel]").val(label);
                }

                // trigger the change event on the ChargeAmount field for things like updating the payment intent for Stripe
                $("input[Name=ChargeAmount]").trigger("change");
            };

            var GetSelectedPaymentOptionAmount = function (refreshInstallmentsTable) {

                let data = {
                    preview: $("#PreviewMode").val(),
                    isReservation: $("#IsReservation").val(),
                    costInstallmentId: YouLi.Trip.Checkout.SelectedInstallmentId,
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    couponCode: $("#ChargeCouponCode").val(),
                    selectedTripPackageId: $("#SelectedPackageId").val(),
                    selectedBookingAddOnOptionId: $("input[type=radio][name=BookingAddOnOption]:checked").val(),
                    isCheckoutFlow: true,
                    numberInviteesInCheckout: $("#NumberInviteesInCheckout").val(),
                    inviteesWithAddOnResponses: GetInviteeDetailsData(),
                    gangs: GetGangsDetailsData($("#MainTourGangSetup")),
                    preTripGangs: GetGangsDetailsData($("#PreTourGangSetup")),
                    postTripGangs: GetGangsDetailsData($("#PostTourGangSetup")),
                    refreshInstallmentsTable: refreshInstallmentsTable,
                    chargeReservationNumber: $('#ChargeReservationNumber').val(),
                }

                data.gangInvoiceAndViewMode = YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode();

                YouLi.Common.Post({
                    url: '/trip/getinstallmentamount',
                    params: data,
                }).then(function (response) {
                    if (response.url) {
                        window.location.href = response.url;
                    }
                    else if (response.success === false) {
                        YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                    }
                    else {
                        YouLi.PaymentChargeForm.AmountDue = response.installmentAmountDue;

                        if (response.installmentIsBalance) {
                            const bookingAddOnOptionTotalPrice = GetBookingAddOnOptionTotalPriceDue();
                            YouLi.PaymentChargeForm.AmountDue -= bookingAddOnOptionTotalPrice;
                        }

                        if (YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode() == "paytogether") {
                            $(".cost-line-item-text-installment-label").html(response.installmentLabel);
                            $(".cost-line-item-total-invitee").addClass("hidden");
                        }
                        else {
                            $(".cost-line-item-text-installment-label").html(`Your ${response.installmentLabel}`);
                            $(".cost-line-item-total-invitee").removeClass("hidden");
                            $(".cost-line-item-amount-total-invitee").html(YouLi.PaymentChargeForm.GetFormattedCurrency(response.paySeparatelyInviteePrepayTotal));
                        }

                        if (response.newInstallmentsTableHtml && $(".cost-installments-selection").length > 0) {
                            $(".cost-installments-selection").html(response.newInstallmentsTableHtml);
                        }

                        UpdateChargeDetails(response.chargeLabel);

                        $("input[Name=ChargeInstallmentId]").val(YouLi.Trip.Checkout.SelectedInstallmentId);
                    }
                });
            };

            var InitialisePaymentDetails = function () {

                ChangePaymentOption($("input[type=radio][name=PaymentOption]:checked").val());
                ChangeMethodOrOptions($("input[type=radio][name=PaymentMethod]:checked").val(), true);
            }

            var ScrollToInvalid = function () {
                var errorElements = document.querySelectorAll(".has-error");

                if (errorElements.length == 0)
                    return;

                $('html, body').animate({
                    scrollTop: $(errorElements[0]).focus().offset().top - 80
                }, 1000);
            }

            var hasBillingAddress = function () {
                return $("#BillToFieldsIncluded") && $("#BillToFieldsIncluded").val() == "true";
            }

            var continuePayment = function () {

                YouLi.Common.UI.ShowInputLoading($(".pay-now-button"));

                var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                switch (selectedPaymentMethod) {
                    case "thirdpartycard":

                        if (!$("#PaymentCostChargingDetailsForm").valid()) {
                            ScrollToInvalid();
                            YouLi.Common.UI.HideInputLoading($(".pay-now-button"));
                            return;
                        }

                        $("#SavedThirdPartyCardConfirmationDialog .current-payment-amount").text(
                            YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));

                        $("#SavedThirdPartyCardConfirmationDialog").modal("show");

                        break;
                    case "paymentgateway":
                        doContinueStripePayment();
                        break;
                    case "banktransfer":
                    case "paypallink":
                    case "phone":
                    case "customlink":
                        YouLi.Common.UI.ShowLoading();

                        processCheckout(selectedPaymentMethod)
                            .then(() => {
                                YouLi.Common.UI.HideLoading();
                            }).catch((errorObject) => {
                            console.error('Error:', errorObject.message);

                            YouLi.Common.UI.HideLoading();
                        });
                        break;
                }

                // this is for stripe surcharge capping payment methods to allow payment form to load.
                const isStripe= $('input[type=radio][name=PaymentMethod]:checked').data('is-stripe');

                if(YouLi.Trip.SurchargeCapping.IsSurchargeCappingEnabled && isStripe) {
                    doContinueStripePayment();
                }
            };

            function continuePaymentOrDoCountryCapping() {
                UpdateChargeLabelFromPrimaryInvitee();
                UpdateBillToEmailFromPrimaryInvitee();
                UpdateChargeDetails(undefined);
                const selectedPaymentMethodSurchargePercent = parseFloat($('input[type=radio][name=PaymentMethod]:checked').data('surcharge-percent')) || 0;

                if (YouLi.Trip.SurchargeCapping.IsSurchargeCappingEnabled && selectedPaymentMethodSurchargePercent > 0) {
                    YouLi.Trip.SurchargeCapping.CallbackForModalConfirm = continuePayment;
                    $('#SurchargeCappingCountryModal').modal('show');
                } else {
                    continuePayment();
                }
            }

            function doContinueStripePayment() {
                YouLi.Common.UI.ShowLoading();

                //google tag manager
                var gaData = YouLi.Common.GetGAData("begin_checkout");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(gaData);

                if (YouLi.Trip.Checkout.ConnectedPaymentGateway === YouLi.Trip.Checkout.PaymentGateway.Stripe) {
                    YouLi.CreditCardPaymentForm.StripePay.InitialiseStripe()
                        .then(() => {
                            YouLi.Common.UI.HideLoading();

                            YouLi.CreditCardPaymentForm.IsRegisteredWithPayment = true;
                            $('#GenericPaymentFormDialog').modal('show');
                        })
                }
                else {
                    YouLi.Common.UI.HideLoading();
                    $('#GenericPaymentFormDialog').modal('show');
                }

                YouLi.Common.UI.HideInputLoading($(".pay-now-button"));
            }

            /* Returns a promise */
            var processCheckout = function (paymentMethod) {

                $(".checkout-payment-error").addClass("hidden");

                let data = {
                    preselectedFreeTextRoom: $("#PreselectedFreeTextRoom").val(),
                    gangName: $("#GangName").val(),
                    inviteesWithAddOnResponses: GetInviteeDetailsData(),
                    gangs: GetGangsDetailsData($("#MainTourGangSetup")),
                    preTripGangs: GetGangsDetailsData($("#PreTourGangSetup")),
                    postTripGangs: GetGangsDetailsData($("#PostTourGangSetup")),
                    isReservation: $("#IsReservation").val(),
                    paymentMethod: paymentMethod,
                    checkoutPrefillId: $("#CheckoutPrefillId").val()
                };

                if (paymentMethod === "stripe") {
                    const pmType = YouLi.CreditCardPaymentForm.SelectedPaymentMethodType;
                    if (pmType) {
                        data.paymentMethodType = pmType;
                    }

                    const isIntentionToEnrolInAutoPay = $("#GenericPaymentFormDialog #EnrolInAutoPay").is(":checked");
                    if (isIntentionToEnrolInAutoPay) {
                        data.isIntentionToEnrolInAutoPay = true;
                    }

                    const stripeIntegrationType = YouLi.CreditCardPaymentForm.StripeIntegrationType;
                    if (stripeIntegrationType) {
                        data["stripeIntegrationType"] = stripeIntegrationType;
                    }
                }

                data["gangInvoiceAndViewMode"] = YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode();

                var paymentChargeFormData = new FormData($("#PaymentChargeForm")[0]);
                for (let pair of paymentChargeFormData.entries()) {
                    data[pair[0]] = pair[1];    // add the form field data
                }

                data["isRegisteredWithPayment"] = true; // always true for checkout page

                if (YouLi.Trip.Checkout.RefundProtectOptedOutConfirmed)
                    data["optedOutRefundProtect"] = true;

                data["RefundProtectSelection"] = YouLi.Trip.Checkout.GetRefundProtectSelection();

                data["includedBillingAddress"] = hasBillingAddress();
                if (hasBillingAddress()) {
                    // add credit card form details like billing details
                    var creditCardFormData = new FormData($('#GenericPaymentForm')[0]);
                    for (let pair of creditCardFormData.entries()) {
                        data[pair[0]] = pair[1];
                    }
                }

                if ($('input[type=radio][name=PaymentMethod]:checked').val() === "thirdpartycard") {
                    data["IsThirdPartyCardPayment"] = true;
                    data["ThirdPartyCardPaymentMethodId"] = $("#ThirdPartyCardPaymentMethodId").val();
                    data["ThirdPartyCardPaymentCostCentre"] = $("#ThirdPartyCardPaymentCostCentre").val();
                    data["ThirdPartyCardPaymentDepartment"] = $("#ThirdPartyCardPaymentDepartment").val();
                    data["ThirdPartyCardPaymentApprovedBy"] = $("#ThirdPartyCardPaymentApprovedBy").val();
                }

                // For payment methods that use the Generic Credit Card popup,
                // hide the modal - do this after we've grabbed out the form data
                if ($("#GenericPaymentFormDialog").hasClass("in"))
                    YouLi.Common.UI.ShowButtonLoading($("#p-creditcard"));

                return new Promise((resolve, reject) => {
                    YouLi.Common.Post({
                        url: '/trip/checkoutinviteerespond/',
                        params: data,
                        suppressLoading: true,
                        errorCallback: function () {
                            if ($("#GenericPaymentFormDialog").hasClass("in")) {
                                YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                                $("#GenericPaymentFormDialog").modal("hide");
                            }

                            YouLi.Common.UI.HideInputLoading($(".pay-now-button"));

                            $(".checkout-payment-error").removeClass("hidden");
                            $(".payment-error-message").text("");

                            reject({
                                message: "checkoutinviteerespond failed",
                                errorHandled: true
                            });
                        }
                    }).then(function (response) {
                        if (response.statusCode === 500 || response.success === false) {
                            if ($("#GenericPaymentFormDialog").hasClass("in")) {
                                YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                                $("#GenericPaymentFormDialog").modal("hide");
                            }

                            YouLi.Common.UI.HideInputLoading($(".pay-now-button"));

                            let errorMessages = [];
                            $.each(response.errors, function () {
                                errorMessages.push(this[this.length - 1].ErrorMessage);
                            });

                            $(".payment-error-message").text(errorMessages.join(", "));

                            if (paymentMethod === 'paypal') {
                                $('.checkout-payment-paypal-error').removeClass('hidden');
                                $('html, body').animate({
                                    scrollTop: $('.checkout-payment-paypal-error').offset().top - 80
                                }, 1000);

                            } else {
                                $('.checkout-payment-error').removeClass('hidden');
                                $('html, body').animate({
                                    scrollTop: $('.checkout-payment-error').offset().top - 80
                                }, 1000);

                            }

                            return reject({
                                message: "checkoutinviteerespond failed",
                                errorHandled: true
                            });
                        }
                        else {
                            YouLi.Common.UI.ClearClientSideErrors();

                            if (YouLi.Common.GetGAData != null) {
                                var gaData = YouLi.Common.GetGAData("purchase");
                                dataLayer.push({ ecommerce: null });
                                dataLayer.push(gaData);
                            }

                            if (response.url) {
                                window.location.href = response.url;
                                if (response.reload)
                                    location.reload();
                            } else {
                                // return the new payment ID (for things like Stripe)
                                const newPaymentId = response.newPaymentId;
                                const couponPaymentId = response.couponPaymentId;
                                const redirectURL = response.tripPageRedirectURI;
                                return resolve({ newPaymentId, couponPaymentId, redirectURL });
                            }
                        }
                    });
                });
            };

            var PushRemoveCartGAData = function () {
                //remove_from_cart event
                var removeFromCartData = YouLi.Common.GetGAData("remove_from_cart");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(removeFromCartData);
            }

            var PushAddCartGAData = function () {
                //add_to_cart
                var removeFromCartData = YouLi.Common.GetGAData("add_to_cart");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(removeFromCartData);
            }

            var ClearArrivalDepartureDateEvents = function () {
                $(document).off("dp.change", ".cost-package-personalised-trip-dates .datepicker");
            };

            var SetupArrivalDepartureDateEvents = function () {
                $(document).off("dp.change", ".cost-package-personalised-trip-dates .datepicker");
                $(document).on("dp.change", ".cost-package-personalised-trip-dates .datepicker", function () {
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true);
                });
            };

            const InitialiseGangEmailEvent = function () {

                $(document).off('blur', '.gang-email');
                $(document).on('blur', '.gang-email', function (e) {
                    const elem = $(this);
                    const newValue = elem.val();
                    const oldValue = elem.data('old-value');

                    if (oldValue === newValue || newValue === '') {
                        return;
                    }

                    const param = {
                        tripId: $("#TripId").val(),
                        email: newValue
                    }

                    YouLi.Common.Get({
                        url: '/trip/GetTripInviteeIsBooked',
                        params: param
                    }).then(function (response) {
                        elem.siblings('.email-paid-warning').toggle(response);
                        elem.attr('data-old-value', newValue);
                    });
                });
            }

            const initialiseValidator = function () {

                $.validator.unobtrusive.parse($("#GangSetupForm"));
                $.validator.unobtrusive.parse($("#TripConsentForm"));

                if ($("#RefundProtectConfirmationForm").length > 0)
                    $.validator.unobtrusive.parse("#RefundProtectConfirmationForm")

                // setup email validation if required
                if (YouLi.Trip.Checkout.EmailDomainValidationWhitelist.length > 0) {
                    const allowedDomains = YouLi.Trip.Checkout.EmailDomainValidationWhitelist.map(function (domain) {
                        return domain.trim().toLowerCase();
                    });

                    $.validator.addMethod('emailDomainValid', function (value, element) {
                        if (!value)
                            return true;

                        const emailParts = value.split('@');
                        if (emailParts.length !== 2)
                            return false;

                        const emailDomain = emailParts[1].trim().toLowerCase();

                        return allowedDomains.includes(emailDomain);

                    }, YouLi.Trip.Checkout.EmailDomainValidationErrorText);

                    $('.gang-email').each(function () {
                        $(this).rules('add', {
                            emailDomainValid: true
                        });
                    });
                }

                YouLi.Validation.Init();
            }

            const InitialiseGangEventHandlers = function () {

                // Add Gang Button
                $(document).off("click", ".btn-add-gang");
                $(document).on("click", ".btn-add-gang", function () {
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true, { addGang: true, affectedTrip: $(this).data('trip-type') });
                });

                // Remove Gang Button
                $(document).off("click", ".btn-remove-gang");
                $(document).on("click", ".btn-remove-gang", function () {
                    var gangIndex = $(this).data("gang-index");
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true, { removeGangIndex: gangIndex, affectedTrip: $(this).data('trip-type') });
                });

                // Gang Package Selector
                $(document).off("change", ".gang-package-selector");
                $(document).on("change", ".gang-package-selector", function () {
                    // Package selection affects price, so update
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true);
                });

                // Manage Guests Button
                $(document).off("click", ".lnk-manage-guests");
                $(document).on("click", ".lnk-manage-guests", function () {
                    gangSetupCurrentGangIndex = $(this).data("gang-index");
                    const tripType = $(this).data("trip-type");
                    const packageName = $(this).data("gang-package-name");
                    const gangMaxOccupancy = $(this).data("gang-max-occupancy");
                    const gangMinOccupancy = $(this).data("gang-min-occupancy");

                    // Scope all gang hidden input reads/writes to the correct trip (main/pre/post)
                    var gangSetupContext = GetGangSetupContext(tripType);
                    var gangSetupParentSelector = gangSetupContext.parentSelector;
                    var gangFieldPrefix = gangSetupContext.fieldPrefix;

                    // Update modal details
                    $(".manage-guests-gang-name").text("Room " + (gangSetupCurrentGangIndex + 1));
                    $(".manage-guests-package-name").text(packageName);

                    // Store trip type on the modal so the save handler knows which gang list to update
                    $("#ManageGuestsModal .modal-title").data("trip-type", gangSetupContext.tripType);

                    $("#PackageOccupancySection").toggle(gangMaxOccupancy > 1 || gangMinOccupancy > 1);
                    $("#RoomOccupancyLabel").html("");
                    if (gangMinOccupancy > 1)
                        $("#RoomOccupancyLabel").append(`Min Occupancy: ${gangMinOccupancy}`);
                    else if (gangMaxOccupancy > 1)
                        $("#RoomOccupancyLabel").append(`Max Occupancy: ${gangMaxOccupancy}`);

                    // Build guest list
                    var $guestList = $("#GuestAssignmentList");
                    $guestList.empty();

                    // Get currently assigned invitees for this gang
                    var assignedInviteeIdsForGang = [];
                    $(`${gangSetupParentSelector} input[name^="${gangFieldPrefix}Gangs[${gangSetupCurrentGangIndex}].AssignedInviteeIds"]`).each(function () {
                        assignedInviteeIdsForGang.push($(this).val());
                    });

                    // Get all assigned invitees across all gangs (excluding current gang)
                    var allAssignedInviteeIdsForOtherGangs = [];
                    $(".gang-item", gangSetupParentSelector).each(function (gangIdx) {
                        if (gangIdx !== gangSetupCurrentGangIndex) {
                            $(this).find(`input[name^="${gangFieldPrefix}Gangs[${gangIdx}].AssignedInviteeIds"]`).each(function () {
                                var id = $(this).val();
                                if (id) {
                                    allAssignedInviteeIdsForOtherGangs.push(id);
                                }
                            });
                        }
                    });


                    // Build checkbox list from gang members
                    $(".gang-member").each(function (index) {
                        var inviteeId = $(this).find(`#GangInvitees_${index}__Id`).val();

                        // Skip if already assigned to another gang
                        if (allAssignedInviteeIdsForOtherGangs.includes(inviteeId)) {
                            return; // continue to next iteration
                        }

                        var firstName = $(this).find(`#GangInvitees_${index}__FirstName`).val();
                        var lastName = $(this).find(`#GangInvitees_${index}__LastName`).val();
                        var fullName = `${firstName} ${lastName}`.trim() || `Guest ${index + 1}`;

                        var isChecked = assignedInviteeIdsForGang.includes(inviteeId);

                        var $item = $(`
                            <div class="control--checkbox guest-assignment-item">
                                <label class="control">
                                    <span>${fullName}</span>
                                    <input type="checkbox" value="${inviteeId}" ${isChecked ? 'checked' : ''} />
                                    <div class="control__indicator"></div>
                                </label>
                            </div>
                        `);

                        $guestList.append($item);
                    });

                    // Occupancy enforcement logic
                    var maxOccupancy = parseInt($(this).data("gang-max-occupancy"));
                    var minOccupancy = parseInt($(this).data("gang-min-occupancy"));

                    function enforceGuestOccupancy() {
                        var checkedCount = $guestList.find("input[type='checkbox']:checked").length;
                        var $unchecked = $guestList.find("input[type='checkbox']:not(:checked)");

                        if (!isNaN(maxOccupancy) && maxOccupancy > 1) {
                            if (checkedCount >= maxOccupancy) {
                                $unchecked.prop("disabled", true);
                                $unchecked.closest(".control-checkbox").addClass("disabled");
                            } else {
                                $guestList.find("input[type='checkbox']").prop("disabled", false);
                                $guestList.find(".control-checkbox").removeClass("disabled");
                            }
                        }

                        if (checkedCount >= minOccupancy) {
                            $("#SaveGuestAssignmentsBtn").prop("disabled", false);

                            $("#SaveGuestAssignmentsBtnContainer")
                                .popover('destroy');
                        } else {
                            $("#SaveGuestAssignmentsBtn").prop("disabled", true);

                            $("#SaveGuestAssignmentsBtnContainer")
                                .attr("href", "javascript:;")  // don't use "disabled" as then the popover doesn't work!
                                .attr("data-container", "body")
                                .attr("data-toggle", "popover")
                                .attr("data-placement", "top")
                                .attr("data-trigger", "hover")
                                .attr("data-html", "true")
                                .attr("data-content", "Min Occupancy " + minOccupancy)
                                .popover();
                        }
                    }

                    enforceGuestOccupancy();
                    $guestList.on("change", "input[type='checkbox']", function () {
                        enforceGuestOccupancy();
                    });

                    $("#ManageGuestsModal").modal("show");
                });

                // Save Guest Assignments
                $(document).off("click", "#SaveGuestAssignmentsBtn");
                $(document).on("click", "#SaveGuestAssignmentsBtn", function () {
                    if (gangSetupCurrentGangIndex < 0) return;

                    var $modalTitle = $("#ManageGuestsModal .modal-title");
                    var modalTripType = $modalTitle.data("trip-type") || "main";

                    var gangSetupContext = GetGangSetupContext(modalTripType);
                    var gangSetupParentSelector = gangSetupContext.parentSelector;
                    var gangFieldPrefix = gangSetupContext.fieldPrefix;

                    // Collect selected invitee IDs
                    var selectedIds = [];
                    $("#GuestAssignmentList input[type='checkbox']:checked").each(function () {
                        selectedIds.push($(this).val());
                    });

                    // Update hidden fields for this gang
                    var $gangItem = $(gangSetupParentSelector).find(`.gang-item`).eq(gangSetupCurrentGangIndex);

                    // Remove existing hidden fields
                    $gangItem.find('input[name*=".AssignedInviteeIds"]').remove();

                    // Add new hidden fields
                    selectedIds.forEach(function (id, index) {
                        $gangItem.append(
                            $('<input type="hidden" />')
                                .attr('name', `${gangFieldPrefix}Gangs[${gangSetupCurrentGangIndex}].AssignedInviteeIds[${index}]`)
                                .val(id)
                        );
                    });

                    $("#ManageGuestsModal").modal("hide");

                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true);
                });
            }

            $(function () {

                initialiseValidator();

                $(document).off("click");
                $(document).on("click", ".go-back-link", function () {
                    if (history.length > 1)
                        history.back();
                    else
                        window.location.href = $(this).data("logo-link");
                });

                $(document).off("change", "#SelectedPackageId");
                $(document).on("change", "#SelectedPackageId", function () {
                    $('.gang-member').each((index, element) => {
                        $(element).find(`#GangInvitees_${index}__InviteeCategory`).val(null);
                    });
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice();
                });

                $(document).off("change", "#NumberInviteesInCheckout");
                $(document).on("change", "#NumberInviteesInCheckout", function () {
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true);
                });

                $(document).off("change", ".gang-category");
                $(document).on("change", ".gang-category", function () {
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true);
                });

                SetupArrivalDepartureDateEvents();

                $(document).off("click", ".choose-default-package");
                $(document).on("click", ".choose-default-package", function () {
                    $("#SelectedPackageId").prop("selectedIndex", 0).change();
                });

                $(document).off("click", ".choose-free-package");
                $(document).on("click", ".choose-free-package", function () {
                    //$("#SelectedPackageId").prop("selectedIndex", 0).change();

                    var gangFormIsValid = $('#GangSetupForm').valid();

                    var tripConsentFormIsValid = true;
                    if ($("#TripConsentForm").length > 0)
                        tripConsentFormIsValid = $("#TripConsentForm").valid();

                    if (!(gangFormIsValid && tripConsentFormIsValid)) {
                        ScrollToInvalid();
                        return;
                    }

                    YouLi.Common.UI.ShowButtonLoading($(".choose-free-package"));

                    processCheckout(null).then(() => {
                        YouLi.Common.UI.HideButtonLoading($(".choose-free-package"));
                    }).catch((errorObject) => {
                        console.error('Error:', errorObject.message);

                        YouLi.Common.UI.HideButtonLoading($(".choose-free-package"));
                    });
                });

                $(document).off("change", "input[type=radio][name=BookingAddOnOption]");
                $(document).on("change", "input[type=radio][name=BookingAddOnOption]", function () {

                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true);
                });

                // initially select the first payment option and payment method
                // YOULI-8514 remove initial server call
                //$("input[type=radio][name=PaymentOption]").first().prop("checked", true);
                //$("input[type=radio][name=PaymentMethod]").first().prop("checked", true);

                $(document).off("change", "input[type=radio][name=PaymentOption]")
                $(document).on("change", "input[type=radio][name=PaymentOption]", function () {
                    var selectedOption = $(this).val();

                    ChangePaymentOption(selectedOption);
                });

                $(document).off("change", "input[type=radio][name=PaymentMethod]");
                $(document).on("change", "input[type=radio][name=PaymentMethod]", function () {
                    var selectedMethod = $(this).val();

                    ChangeMethodOrOptions(selectedMethod, false, true);

                });

                $(document).off("change", "input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode']")
                $(document).on("change", "input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode']", function () {
                    // trigger change method, but it will just be for updating (same as for refund protect, below)
                    var selectedOption = $('input[type=radio][name=PaymentOption]:checked').val();
                    ChangePaymentOption(selectedOption, /* refreshInstallmentsTable = */true);
                });

                $(document).off("change", "input[type=radio][name='CurrentInvitee.RefundProtectSelection']");
                $(document).on("change", "input[type=radio][name='CurrentInvitee.RefundProtectSelection']", function () {

                    // trigger change method, but it will just be for updating refund protect
                    var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();
                    ChangeMethodOrOptions(selectedPaymentMethod, true, true); // Nb: no scroll when changing Refund Protect

                });

                $(document).off("click", ".show-itinerary-details-link");
                $(document).on("click", ".show-itinerary-details-link", function () {
                    ShowItemDetails($(this).closest(".addon-item-container"));

                    $("#ProgramItemDialog").modal("show");
                });


                // If credit card payemnt form is loaded (it won't be initially for $0 packages)
                if (YouLi.CreditCardPaymentForm) {
                    var selectedOption = $('input[type=radio][name=PaymentOption]:checked').val();
                    YouLi.CreditCardPaymentForm.UpdateAutoPayVisibility(selectedOption != "balance");
                }
                ShowItemDetails = function (gridItemElement) {
                    $(gridItemElement).find(".addon-item-details-contents").clone().appendTo($("#ProgramItemDialog .modal-body").empty()).find(".show-more").remove();
                    $currentlySelectedItem = $(gridItemElement);
                }

                let isPackageSoldout = $(".choose-default-package").data('sold-out');
                if (!isPackageSoldout) {

                    //InitialisePaymentDetails();

                    YouLi.Trip.Checkout.InitialiseResponseChecks();
                }

                $(document).off("click", "#SavedThirdPartyCardConfirmationOk");
                $(document).on("click", "#SavedThirdPartyCardConfirmationOk", function () {

                    $("#SavedThirdPartyCardConfirmationDialog").modal("hide");

                    YouLi.Trip.Checkout.ProcessPaymentWithSavedPaymentMethod(true);
                });

                $(document).off("click", "#SavedThirdPartyCardConfirmationCancel");
                $(document).on("click", "#SavedThirdPartyCardConfirmationCancel", function () {
                    YouLi.Common.UI.HideInputLoading($(".pay-now-button"));
                });

                $(document).off("click", ".apply-coupon-code");
                $(document).on("click", ".apply-coupon-code", function () {

                    $(".content-trip-coupon-code-error").addClass("hidden");

                    let selectedCouponCode = $("#SelectedCouponCode").val();

                    let data = {
                        couponCode: selectedCouponCode,
                        preview: $("#PreviewMode").val(),
                        isReservation: $("#IsReservation").val(),
                        tripId: $("#TripId").val(),
                        inviteeId: $("#InviteeId").val(),
                        installmentId: YouLi.Trip.Checkout.SelectedInstallmentId,
                        selectedTripPackageId: $("#SelectedPackageId").val(),
                        selectedBookingAddOnOptionId: $("input[type=radio][name=BookingAddOnOption]:checked").val(),
                        isCheckoutFlow: true,
                        numberInviteesInCheckout: $("#NumberInviteesInCheckout").val(),
                        inviteesWithAddOnResponses: GetInviteeDetailsData(),
                        gangs: GetGangsDetailsData($("#MainTourGangSetup")),
                        preTripGangs: GetGangsDetailsData($("#PreTourGangSetup")),
                        postTripGangs: GetGangsDetailsData($("#PostTourGangSetup")),
                    };

                    data.gangInvoiceAndViewMode = YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode();

                    YouLi.Common.Post({
                        url: '/trip/applycouponcode/',
                        params: data,
                    }).then(function (response) {
                            if (response.url) {
                                window.location.href = response.url;
                            }
                            else if (response.success === false) {
                                YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                            }
                            else if (response.errorMessage) {
                                $(".content-trip-coupon-code-error").removeClass("hidden")
                                $("#CouponCodeErrorMessage").text(response.errorMessage);
                            }
                            else {
                                //google tag manager
                                var gaData = YouLi.Common.GetGAData("select_promotion");
                                dataLayer.push({ ecommerce: null });
                                dataLayer.push(gaData);

                                var initialSelectedInvoiceAndViewMode = $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode']:checked").val();
                                var initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]:checked").val();
                                var initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();

                                // when a coupon code is applied, we have to update the installments table, the charge details section and the actual charge form amounts if it is a balance being paid.
                                $("#ChargeDetails").html(response.newCheckoutPaymentChargeDetailsHtml);

                                if ($(".cost-installments-selection").length > 0) {
                                    $(".cost-installments-selection").html(response.newInstallmentsTableHtml);
                                }

                                if (YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode() != "paytogether") {
                                    $(".cost-line-item-amount-total-invitee").html(YouLi.PaymentChargeForm.GetFormattedCurrency(response.paySeparatelyInviteePrepayTotal));
                                }

                                // update the charge details line item for coupon code
                                $("input[Name=ChargeCouponCode]").val(selectedCouponCode);
                                $(".coupon-code-value").html(selectedCouponCode);
                                $(".cost-line-item-amount-coupon-code").html(`-${YouLi.PaymentChargeForm.GetFormattedCurrency(response.couponCodeAmount)}`);
                                $(".cost-line-item-coupon-code").removeClass("hidden");

                                initialiseValidator();

                                if (!initialSelectedPaymentMethod)
                                    initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]").first().val();
                                if (!initialSelectedPaymentOption)
                                    initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]").first().val();

                                $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode'][value=" + initialSelectedInvoiceAndViewMode + "]").attr("checked", true);
                                $("input[type=radio][name=PaymentMethod][value=" + initialSelectedPaymentMethod + "]").attr("checked", true);
                                $("input[type=radio][name=PaymentOption][value=" + initialSelectedPaymentOption + "]").attr("checked", true);
                                InitialisePaymentDetails();
                            }

                    });
                });

                $(document).off('click', '#ViewInvoiceButton');
                $(document).on('click', '#ViewInvoiceButton', function (e) {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 1000);
                });

                $(document).off("click", ".pay-now-button");
                $(document).on("click", ".pay-now-button", function () {

                    // Special: even if the gang email is disabled, we want to enable it to ensure the provided value is VALID
                    $('.gang-email:disabled').each(function () {
                        $(this).prop('disabled', false);
                        $(this).valid();
                        $(this).prop('disabled', true);
                    });

                    var gangFormIsValid = $('#GangSetupForm').valid();

                    var tripConsentFormIsValid = true;
                    if ($("#TripConsentForm").length > 0)
                        tripConsentFormIsValid = $("#TripConsentForm").valid();

                    if (!(gangFormIsValid && tripConsentFormIsValid)) {
                        ScrollToInvalid();
                        return;
                    }

                    YouLi.Trip.Checkout.RefundProtectOptedOutConfirmed = false;

                    if ($("#RefundProtectConfirmationDialog").length > 0 && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']").length > 0 && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val().toLowerCase() == "optedout") {
                        $("#RefundProtectConfirmationDialog").modal("show");
                        return;
                    }

                    continuePaymentOrDoCountryCapping();
                });

                $(document).on("click", "#RefundProtectConfirmationFormOk", function () {

                    if (!$("#RefundProtectConfirmationForm").valid())
                        return;

                    $("#RefundProtectConfirmationDialog").modal("hide");

                    YouLi.Trip.Checkout.RefundProtectOptedOutConfirmed = true;

                    continuePayment();
                });

                // The following event handling for the date-time update is now included in the TaskResponseFieldDateTime partial
                function UpdateDateTimeAnswer(element) {
                    var container = element.closest(".date-time-container");
                    var datePicker = $('.datepicker', container).data("DateTimePicker");
                    var timePicker = $('.timepicker', container).data("DateTimePicker");
                    if (!datePicker || datePicker.date() == null || !timePicker || timePicker.date() == null) {
                        $(".combined-date-time-answer", container).val("");
                    }
                    else {
                        $(".combined-date-time-answer", container).val(
                            datePicker.date().format("D/M/Y ") + timePicker.date().format("hh:mm A"));
                    }
                };

                $(document).on("dp.change", ".date-time-container .datepicker", function (e) {
                    UpdateDateTimeAnswer(this);
                });

                $(document).on("dp.change", ".date-time-container .timepicker", function (e) {
                    UpdateDateTimeAnswer(this);
                });

                $(document).on('keypress', '.gang-last-name , .gang-first-name', function (e) {
                    //64 is char '@'
                    if (e.which === 64) {
                        e.preventDefault();
                    }
                });

                $(document).on('click', '.save-card-login a', function (e) {
                    e.preventDefault();
                    const returnUrl = window.location.pathname;
                    const persona = 'traveler';
                    const redirectUrl = $(this).attr('href');

                    window.location.href = `${redirectUrl}?returnUrl=${returnUrl}&defaultPersona=${persona}`;
                })

                // Add event for when entering name should be applied to billing info so that it can be sent to stripe customer creation
                $(document).off('input', '.gang-first-name').on('input', '.gang-first-name', function (e) {
                    if ($(this).is($('.gang-first-name').first())) {
                        $('#p-billto-first-name').val($(this).val());
                    }
                });

                $(document).off('input', '.gang-last-name').on('input', '.gang-last-name', function (e) {
                    if ($(this).is($('.gang-last-name').first())) {
                        $('#p-billto-last-name').val($(this).val());
                    }
                });

                InitialiseGangEmailEvent();
                //view_item
                var data = YouLi.Common.GetGAData("view_item");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(data);

                //add_to_cart
                var removeFromCartData = YouLi.Common.GetGAData("add_to_cart");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(removeFromCartData);

                prevState.isPackageCategory = $('.gang-member').find('#GangInvitees_0__InviteeCategory').is(':hidden');

                // Trim fields that we do not want to allow spaces in
                $(".trim-before-validation").on("blur", function () {
                    $(this).val($(this).val().trim());
                });

                // Initialise gang event handlers if gangs setup section exists
                if ($(".gangs-setup").length > 0) {
                    InitialiseGangEventHandlers();
                }
            });

        }(YouLi.Trip.Checkout ? YouLi.Trip.Checkout : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));